import { Box, Typography } from "@mui/material";
import { slugify } from "@covertree/utils";
import { CoveredOptionName } from "@covertree/new-business-graphql";

import { LoadingOverlay } from "../../loading";
import { ElementAccordionItem } from "./Item";
import { CustomAccordion } from "../customAccordion";
import { getCoveredItemDetails } from "./getItemDetails";

interface Props {
  title: string;
  items: CoveredOptionName[];
  isCovered: boolean;
  expandOnInit?: boolean;
  dataTestId?: string;
}

export function PersonalizedQuotesElementAccordion({
  title,
  items,
  isCovered,
  expandOnInit,
  dataTestId,
}: Props) {
  return (
    <Box mt={5} data-testid={`${dataTestId}-container`}>
      <CustomAccordion
        expandOnInit={expandOnInit ?? true}
        content={
          <Box display="flex" flexDirection="column" width="100%">
            {items.length === 0 ? (
              <Box mt={2} position="relative">
                <LoadingOverlay small />
              </Box>
            ) : (
              items.map((item) => {
                const { title, description, icon } = getCoveredItemDetails(
                  item,
                  isCovered
                );

                return (
                  <ElementAccordionItem
                    dataTestId={slugify(`${title}`)}
                    key={title}
                    title={title}
                    icon={icon}
                    description={description ?? <></>}
                  />
                );
              })
            )}
          </Box>
        }
        header={() => (
          <Typography
            data-testid={dataTestId}
            variant="h3"
            sx={(theme) => ({
              fontWeight: 400,
              [theme.breakpoints.down("xs")]: {
                fontSize: "1.5rem",
              },
            })}>
            {title}
          </Typography>
        )}
        withoutAccent
        withoutBorder
        arrowToRight
      />
    </Box>
  );
}
